import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => {
    return {
        card: {
            width: "100%",
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        },
    };
});
